import { TextField, Tooltip } from '@material-ui/core';
import React from 'react';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import {
    withStyles
} from "@material-ui/core/styles";
import PropTypes from 'prop-types';

const CustomPasswordInput = ({
    label,
    className,
    required,
    labelStyle,
    endAdornment,
    InputProps,
    ...rest
}) => {

    const hint = `Création de votre mot de passe :
    • Longueur : les mots de passe doivent comporter au moins 8 caractères.
    • Complexité : les mots de passe doivent inclure une combinaison de lettres majuscules, de lettres minuscules, de chiffres et de caractères spéciaux (par exemple !, @, #, $, %, ^, &, *).`;
    return (
        <TextField
            {...rest}
            InputProps={{
                ...InputProps,
                endAdornment: <BlueOnGreenTooltip title={<span style={{ whiteSpace: 'pre-line' }}>{hint}</span>}>
                    <InfoOutlinedIcon style={{
                        cursor: "pointer",
                        marginRight: 4
                    }} />
                </BlueOnGreenTooltip>
            }}
        />
    );
};

CustomPasswordInput.propTypes = {
    label: PropTypes.string,
    className: PropTypes.string,
    required: PropTypes.bool,
    labelStyle: PropTypes.any,
    endAdornment: PropTypes.any,
    InputProps: PropTypes.any,
};
export default CustomPasswordInput;

const BlueOnGreenTooltip = withStyles({
    tooltip: {
        color: "#263238",
        backgroundColor: "white",
        fontSize: 12,
        fontWeight: "bold",
        boxShadow: "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)"
    }
})(Tooltip);
